<template>
	<footer :class="`footer footer-${theme ? theme : ''}`">
		<div class="footer-copy">
			<div class="footer-col footer-logo">
				<a href="https://www.artlebedev.ru/"><img :src="`/static/als-logo${theme ? '' : '-white' }.svg`"></a>
			</div>
			<div class="footer-col">
				<p>Задизайнено в&nbsp;<a class="white" href="https://www.artlebedev.ru/">Студии Артемия Лебедева</a></p>
				<p><a class="white" href="https://www.artlebedev.ru/vkusomer/">Информация о&nbsp;сайте</a></p>
			</div>
		</div>
	</footer>
</template>

<script>

export default {
  name: 'footer',
  props: ['theme'],
};
</script>

<style>
@keyframes footer{
  from,20%{
    transform: translate3d(0,20px,0);
    opacity: 0;
  }
  to{
    transform: translate3d(0,0,0);
    opacity: 1;
  }
}
.footer{
	animation: footer .4s ease-in-out;
	animation-delay: .2s;
	position: absolute;
	padding: 5px 15px 0;
	font-size: 80%;
	color: white;
	width: 100%;
	z-index: 99;
	bottom: 0;

	@media (max-width: $mediaMob) {
		padding-top: 10px;
    font-size: 70%;
	}

	&-dark{
		transform: translate3d(-50%,0,0);
		padding: 20px 15px 30px;
		text-align: left;
		width: initial;
		color: black;
		left: 50%;

		@media (max-width: $mediaIpad){
			padding-left: 0;
			transform: none;
			left: initial;
		}

		@media (max-height: 700px) {
			position: relative;
			z-index: -1;
		}

		.footer-copy{
			margin: 0 auto;
		}
		a{
			border-bottom-color: rgba(0,0,0,.3);
			color: black;
		}
	}


	&-copy{
		display: block;
		margin: 0 auto 15px;

		@media (min-width: $mediaMob) {
			width: 440px;
		}
		@media (max-width: $mediaMob){
			margin-bottom: 0;
		}
	}

	&-logo{

		@media (max-width: 400px){
			margin-bottom: 4px;
		}
		a{
			border-bottom: 0;
		}
	}

	&-col{
		display: inline-block;
		vertical-align: top;
		margin-right: 6px;
		line-height: 1;
	}


}
</style>



// WEBPACK FOOTER //
// Footer.vue?1e1164b0